import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { TrendingUp, ShoppingBag, Clock, AlertTriangle, Users } from 'lucide-react';
import { api } from '../../api/client';
import { adminGetOrders } from '../../api/orders';
import styles from './DashboardPage.module.css';

const getAnalytics = () => api.get('/admin/analytics').then(r => r.data.data);

export default function DashboardPage() {
  const { t } = useTranslation();
  const { data: stats } = useQuery({ queryKey: ['admin-analytics'], queryFn: getAnalytics });
  const { data: ordersData } = useQuery({
    queryKey: ['admin-orders-recent'],
    queryFn: () => adminGetOrders({ limit: '5' }),
  });

  const cards = stats ? [
    { icon: TrendingUp, label: t('admin.total_revenue'), value: `₹${stats.totalRevenue?.toLocaleString('en-IN') || 0}`, color: '#8B1A1A' },
    { icon: ShoppingBag, label: t('admin.total_orders'), value: stats.totalOrders || 0, color: '#1565c0' },
    { icon: Clock, label: t('admin.pending_orders'), value: stats.pendingOrders || 0, color: '#e65100' },
    { icon: Users, label: 'Subscribers', value: stats.totalSubscribers || 0, color: '#2e7d32' },
  ] : [];

  const STATUS_COLORS: Record<string, string> = {
    pending_payment: '#e65100', confirmed: '#1565c0', processing: '#6a1b9a',
    shipped: '#00838f', delivered: '#2e7d32', cancelled: '#c62828',
  };

  return (
    <div>
      <h1 className={styles.pageTitle}>{t('admin.dashboard')}</h1>

      <div className={styles.statsGrid}>
        {cards.map(({ icon: Icon, label, value, color }) => (
          <div key={label} className={styles.statCard}>
            <div className={styles.statIcon} style={{ background: color + '15', color }}>
              <Icon size={24} />
            </div>
            <div>
              <div className={styles.statValue}>{value}</div>
              <div className={styles.statLabel}>{label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.recentSection}>
        <h2 className={styles.sectionTitle}>Recent Orders</h2>
        <div className={styles.table}>
          <div className={styles.tableHeader}>
            <span>Order ID</span>
            <span>Customer</span>
            <span>Total</span>
            <span>Status</span>
            <span>Date</span>
          </div>
          {(ordersData?.orders || []).map((order: Record<string, unknown>) => (
            <div key={order.id as string} className={styles.tableRow}>
              <span className={styles.orderId}>#{(order.id as string).slice(0, 8).toUpperCase()}</span>
              <span>{order.userPhone as string}</span>
              <span>₹{(order.total as number)?.toLocaleString('en-IN')}</span>
              <span>
                <span className={styles.status} style={{ background: STATUS_COLORS[order.status as string] + '20', color: STATUS_COLORS[order.status as string] }}>
                  {order.status as string}
                </span>
              </span>
              <span>{new Date(order.createdAt as string).toLocaleDateString('en-IN')}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
